import React, {
  useReducer, useEffect, useState,
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { ErrorHandler, InfiniteScrollComponent } from '@playbookux/playbook-web-core';
import { TagsZeroState } from '../../../zero-state';
import NoResultMessage from '../../../no-results';
import SearchResultCard from '../../../../../core/components/search-result-card';
import useDispatchToActions from '../../../../../core/utils/dispatch';
import useSearch from '../../../../../core/hooks/use-search';
import ProjectsDropdown from '../../../../../core/components/projects-dropdown';

import {
  AddButton,
  ClearButton,
  Container,
  ContainerButton,
  ContainerDropdown,
  ContainerInputSearch,
  InputSearch,
  TextTotal,
} from './styles';

import reducer, { initialState } from '../reducer';

import {
  setSelectedCard,
  setClearSelection,
  setSearch,
} from '../actions';

const ListTagHighlights = (props) => {
  const {
    companyId,
    isModalOpen,
    onSetTags,
    project,
  } = props;

  const [state, dispatch] = useReducer(reducer, initialState);
  const [selectedProjects, setSelectedProjects] = useState([{ id: project.id, name: project.name }]);

  const dispatchToActions = useDispatchToActions({
    setSelectedCard,
    setClearSelection,
    setSearch,
  }, dispatch);

  const {
    setSelectedCard: onSetSelectedCard,
    setClearSelection: onSetClearSelection,
    setSearch: onSetSearch,
  } = dispatchToActions;

  const { selectedCards, search } = state;

  const {
    error,
    dataSearch = {},
    fetchMore,
    hasMore,
  } = useSearch(companyId, search, _.map(selectedProjects, 'id'), 'Highlights');

  const { search: tagHighlitghs = [] } = dataSearch;

  useEffect(() => {
    if (isModalOpen) {
      onSetClearSelection();
    }
  }, [isModalOpen, onSetClearSelection]);

  const handleCardClick = (tagHighlight) => {
    onSetSelectedCard(tagHighlight);
  };

  const handleClick = () => {
    onSetTags(selectedCards);
  };

  const handleSearchChange = (e, { value }) => onSetSearch(value);

  const zeroState = tagHighlitghs && _.isEmpty(tagHighlitghs);
  const noResults = zeroState && !_.isEmpty(search);

  if (error) {
    return (
      <Container>
        <ErrorHandler
          error={error}
          defaultMessage="Error while retrieving tags."
        />
      </Container>
    );
  }

  return (
    <>
      <Container>
        <ContainerInputSearch>
          <InputSearch
            icon="search"
            placeholder="Search tags"
            input={{
              icon: 'search',
              iconPosition: 'left',
            }}
            onSearchChange={handleSearchChange}
            showNoResults={false}
            value={search}
          />

          <ContainerDropdown>
            <ProjectsDropdown
              companyId={companyId}
              setSelectedProjects={setSelectedProjects}
              selectedProjects={selectedProjects}
              isDisabled
            />
          </ContainerDropdown>
        </ContainerInputSearch>

        {zeroState && !noResults && <TagsZeroState />}
        {noResults && <NoResultMessage />}

        {!zeroState && !noResults && (
          <InfiniteScrollComponent
            hasMore={hasMore}
            onLoadMore={fetchMore}
          >
            {tagHighlitghs.map((tagHighlight) => (
              <SearchResultCard
                highlight={tagHighlight}
                isSelectable
                key={`${tagHighlight.id}-${tagHighlight.searchableType}`}
                onCardClick={() => handleCardClick(tagHighlight)}
                selected={!!selectedCards[tagHighlight.id]}
                text={search}
              />
            ))}
          </InfiniteScrollComponent>
        )}
      </Container>

      <ContainerButton>
        <TextTotal>
          {`${_.keys(selectedCards).length} Selected `}
          <ClearButton onClick={onSetClearSelection}>
            Clear
          </ClearButton>
        </TextTotal>

        <AddButton
          disabled={_.isEmpty(selectedCards)}
          onClick={handleClick}
        >
          Add
        </AddButton>
      </ContainerButton>
    </>
  );
};

ListTagHighlights.propTypes = {
  companyId: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool,
  onSetTags: PropTypes.func.isRequired,
  project: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

ListTagHighlights.defaultProps = {
  isModalOpen: false,
};

export default ListTagHighlights;
